import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=3c9f89ed&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=3c9f89ed&prod&lang=scss&"
import style1 from "./Loader.vue?vue&type=style&index=1&id=3c9f89ed&prod&scoped=true&lang=css&"
import style2 from "./Loader.vue?vue&type=style&index=2&id=3c9f89ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9f89ed",
  null
  
)

export default component.exports